module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('strong', [_vm._v("NEVER NEVER NEVER GIVE UP")])]), _vm._v(" "), _c('p', {
    staticClass: "authorcenter"
  }, [_c('strong', [_vm._v("— Winston Churchill")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/yellow_star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("The three great essentials to achieve anything worthwhile are, first, hard work; second, stick-to-it-iveness; third, common sense.")]), _vm._v(" "), _c('p', {
    staticClass: "authorcenter"
  }, [_c('strong', [_vm._v("— Thomas A. Edison")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('strong', [_vm._v("Hidden in Plain View")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The key to accomplishing your life’s work and living your wildest dreams is a secret hidden in plain view. It’s a promise we make to ourselves and a road map to fulfill that promise, all wrapped into one package. Wherever someone achieves something worthwhile, whenever someone breathes life into a long-held dream, this singular, special key has opened the door. "), _c('strong', [_vm._v("Stick-to-it-iveness")]), _vm._v(" is a funny word, some might say it’s not even a real word, but it speaks for itself. Sticking to our inspirations, our values, our hopes and dreams. Sticking to our family and friends. Sticking to it even when others tell us to forget it. Sticking with it when we’re facing tough times and when we aren’t sure whether or not we can make it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("When we match stick-to-it-iveness with its natural companions, hard work and common sense, there’s nothing we can’t accomplish. We can all use a little inspiration to help us plant one foot in front of the other, to do what we came into this life to do. Here’s the key, for you and to pass on to those you care about: perseverance, resolve, determination, doggedness, tenacity, staying power, steadfastness, dedication, persistence, commitment, fortitude, grit, endurance, resilience, guts, stamina. Here’s to the power of stick-to-it-iveness!")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/red.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('strong', [_vm._v("“There is no use trying,” said Alice: “one can’t believe impossible things.”")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/red.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("“I dare say you haven’t had much practice,” said the Queen. “When I was your age, I always did it for half-an-hour a day. Why, sometimes I’ve believed as many as six impossible things before breakfast.”")]), _vm._v(" "), _c('p', {
    staticClass: "authorcenter"
  }, [_c('strong', [_vm._v("— Lewis Carroll")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0